import { GridColDef } from "@mui/x-data-grid-pro"
import { FnAxios, FnDialog, I18n, ParseHtml, RouterDOM } from "utilities/utilities";
import { BtnAddOnTableRender, BtnEditOnTableRender, DefaultParamCol } from "../Ticket/components/CreateColumnTable";
import { useEffect, useMemo, useState } from "react";
import { PaginationInterface, initRows } from 'components/DataGrid';
import { useLocation } from "react-router";
import { useForm } from "react-hook-form";
import { APIStatusCode, I18NextNs } from "enum/enum";
import moment from "moment";
import { numberFormatterLocale, parseFloatCheckValue, renderCellUpdate } from "../Ticket/fnTickit";
import _ from "lodash";
import { GetMenuPermissionParamRoute } from "utilities/SystemFunction";

export function useFundIncomePlan() {

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const [isPermission, setIsPermission] = useState<boolean>(false);
    const [nPrmUser, setNPrmUser] = useState(2);
    const [anchorEl, setAnchorEl] = useState(null);
    const [messagePopper, setMessagePopper] = useState("")
    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sUpdate",
        sSortDirection: "desc",
    });

       
     //#region Form
     const formSearch = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    // #endregion

    useEffect(() => {
        GetMenuPermissionParamRoute("/FundIncomePlanList", AxiosFn, setIsPermission, DialogFn);
        getTable(dataRow);
    }, [])


    const getTable = (p: PaginationInterface) => {
        DialogFn.BlockUI();
        
        setLoadingTable(true);
        let Param = {
            ...p,
            arrRows : [],
            nYear: formSearch.getValues("nYear") ? parseInt(moment(formSearch.getValues("nYear")).format('YYYY')) : null,
        };
        AxiosFn.Post(`FundIncomePlan/GetTableFundIncomePlan`, Param, (result) => {
            setLoadingTable(false);
        DialogFn.UnBlockUI();
        let objResult = result.objResult;
            setDataRow({
                ...p,
                arrRows: objResult.lstData,
                nDataLength: objResult.nDataLength,
                nPageIndex: objResult.nPageIndex,
            });
        });
    };
    const onDelete = (arrSelect) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            setLoadingTable(true);
            AxiosFn.Post(`FundIncomePlan/OnDeleteTableFundIncomePlan`, { lstId: arrSelect }, () => {
                DialogFn.UnBlockUI();
                DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent));
                getTable(dataRow)
            });
        });
    }

    const handleClearSearch = () => {
        Object.keys(formSearch.getValues()).forEach((key => {
            formSearch.setValue(key, null);
            formSearch.clearErrors(key);
        }))
        getTable(dataRow);
    };


    const dataColumn: GridColDef[] = [
        {
            ...DefaultParamCol,
            field: "cAction",
            width: 60,
            minWidth : 60,
            headerName: "",
            sortable:false,
            type: "actions",
            flex: 0,
            renderHeader: () => {
                if (isPermission && nPrmUser === 2) {
                    return (
                        <BtnAddOnTableRender
                            path={"/FundIncomePlanForm"}
                            nPermision={nPrmUser}
                        />
                    );
                }
            },
            renderCell: (params) => {
                return (
                    <BtnEditOnTableRender
                        path={"/FundIncomePlanForm"}
                        params={params}
                        nPermision={isPermission ? params.row.isView ? 1 : 2 : 1}
                    />
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nYear",
            headerName: `ประจำปี`,
        },
        {
            ...DefaultParamCol,
            field: "nQ1",
            headerName: `ไตรมาส 1`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value,2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nQ2",
            headerName: `ไตรมาส 2`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value,2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nQ3",
            headerName: `ไตรมาส 3`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value,2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nQ4",
            headerName: `ไตรมาส 4`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value,2)}
                    </>
                );
            },
        },
        // {
        //     ...DefaultParamCol,
        //     field: "sUpdateName",
        //     headerName: `แก้ไขโดย`,
        //     align: "left",
        //     flex: 2,
        // },
        {
            ...DefaultParamCol,
            field: "sUpdate",
            headerName: `วันที่แก้ไขล่าสุด`,
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {renderCellUpdate(params, handleClickUpdate)}
                    </>
                )
            }
        }
    ];

    const handleClickUpdate = (event, params) => {
        setAnchorEl(event.currentTarget);
        setMessagePopper(params.row.sUpdateName)
    };

    return {
        dataColumn,
        getTable,
        onDelete,
        dataRow,
        loadingTable,
        formSearch,
        nPrmUser,
        handleClearSearch,
        anchorEl,
        setAnchorEl,
        messagePopper,
        isPermission
    };
}


export function useFundIncomePlanForm() {

    //#region Hook
    const Router = RouterDOM();
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    const location = useLocation();
    // #endregion

    const objParamPath = useMemo(() => {
        const ParamId = new URLSearchParams(location.search).get("strParam");
        const ParamPrs = 2;
        return { ParamId, ParamPrs }
    }, [location.search])

    //#region State / Usememo
    const [nUserType, setNUserType] = useState(0);
    const [isView, setIsView] = useState(false)
    const [statusId, setStatusId] = useState(0)
    const [policyId, setPolicyId] = useState(0)
    const [objMuseum, setObjMuseum] = useState({
        nMuseumID: null,
        sMuseumName: null,
    })
    const [option, setOption] = useState({
        lstMuseum: [],
        lstSeller: [],
        lstCurrencyNotes: [],
        lstCurrencyCoins: [],
        lstEmpFund: [],
        lstEmpMoney: [],
        lstTicketTypeNotFree: [],
    })
    const [defaultValues, setDefaultValues] = useState({
        dSoldTicket: null,
        nMuseumID: null,
        sMuseum: null,
        arrSeller: null,
        nEmpFund: null,
        nEmpMoney: null,
        lstSoldTicket: [],
        lstReturnTicket: [],
        lstCompareTicket: [],
        lstCurrencyNotes: [],
        lstCurrencyCoins: [],
        lstCurrencyElec: [],
        sRemarkFlow: null,
    })
    const [objTotal, setObjTotal] = useState({
        nTotalTicket: 0,
            nAmount: 0,
            nTotalRemark: 0,
    })
    const [objTotalMoney, setObjTotalMoney] = useState(0)
    
    // #endregion

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: defaultValues
    });
    // #endregion

    const { watch, reset } = form;

    useEffect(() => {
        GetCheckEmpMuseum()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        form.reset(defaultValues);
    }, [defaultValues, form])

    const gotoBack = () => {
        Router.GoToPage("/TicketSoldList")
    }

    const GetCheckEmpMuseum = async () => {
        DialogFn.BlockUI();
        await AxiosFn.Get(`Ticket/GetCheckEmpMuseum`, { nMenuId: 20 }, async (result) => {
          DialogFn.UnBlockUI();
          let objResult = result.objResult;
          setNUserType(objResult.nUserTypeID)
          await getOptionInitialData(objResult.nUserTypeID)
        });
      };

      const ExportPDF = async () => {
        DialogFn.BlockUI();
        let param = {
            sKeyID : "",
        }

        let fileName = `SoldTicket_${moment().format('yyyyMMDDHHmmss')}.pdf`;
        await AxiosFn.DowloadFileBlob("Ticket/ExportPDF", param, fileName, () => {
            DialogFn.UnBlockUI()
            
        },()=>{DialogFn.UnBlockUI()})

    }

    const handleSubmitForm = (sMode) => {
        form.clearErrors()
        //check conditon is pass at table compare
        
        const lstSoldTicket = form.getValues("lstSoldTicket");
        
        let sMessage = "";
        if (sMode === "S") {
            sMessage = "ไม่สามารถยืนยันข้อมูลได้ เนื่องจากรายการจำหน่ายมีจำนวนบัตรไม่ครบถ้วน"
            let sMessageMax = "ไม่สามารถยืนยันข้อมูลได้ เนื่องจากรายการจำหน่ายเกินจำนวนที่สามารถจำหน่ายได้"
            let isPassListSold = true;
            let isPassMax = true;
            lstSoldTicket.forEach((item) => {
                if (item.isPass !== true && item.isRequire && !item.isFree) {
                    isPassListSold = false;
                    sMessage += `<br/>- ${item.sTypeTicket}`;
                }
                let nInput = (parseInt(item.nTotalTicket) + item.lstRemark.length)
                if(item.nMaxTicket < nInput && item.isFree)
                {
                    isPassMax = false;
                    sMessageMax += `<br/>- ${item.sTypeTicket} ${item.nMaxTicket} - ${nInput}`;

                }
              
            })
           
            if (!isPassMax) {
                DialogFn.Warning(sMessageMax);
                return;
            }
            if (!isPassListSold) {
                DialogFn.Warning(sMessage);
                return;
            }
           
        }
        let sumCurrencyElec = 0;
        if (form.getValues("lstCurrencyElec").length > 0) {
            form.getValues("lstCurrencyElec").forEach(element => {
                element.valueInputDecimal = element.valueInputDecimal === "" ? null : element.valueInputDecimal;
            });
             sumCurrencyElec = _.sumBy(form.getValues("lstCurrencyElec"), function (o) { return parseFloatCheckValue(o.valueInputDecimal); });
        }
        let InputSum = objTotalMoney + sumCurrencyElec;

        if (objTotal.nAmount !== InputSum && sMode === "S")
        {
            sMessage = "ไม่สามารถยืนยันข้อมูลได้เนื่องจาก จำนวนเงินไม่สอดคล้องกัน"
            DialogFn.Warning(sMessage);
            return;
        }
        

        const lstCompareTicket = form.getValues("lstCompareTicket");
        let findIndexFalse = lstCompareTicket.findIndex(f => f.isPass !== true);
        if (findIndexFalse !== -1 && sMode === "S") {
            sMessage = "ไม่สามารถยืนยันข้อมูลได้เนื่องจาก มีประเภทบัตรที่สถานะผิดปกติดังนี้ "
            let isPassListCompare = true;
            lstCompareTicket.forEach((item, index) => {
                if (item.isPass !== true ) {
                    isPassListCompare = false;
                    sMessage += `<br/>- ${item.sTypeTicket}`;
                }
            })
            if (!isPassListCompare) {
                DialogFn.Warning(sMessage);
                return;
            }
        }

        let objParam = {
            sMode: sMode,
            sIDTicketSold: objParamPath.ParamId,
            sIDMuseum: objMuseum.nMuseumID + "",
            nPolicyId: policyId,
            nTotalTicket: objTotal.nTotalTicket,
            sAmount: objTotal.nAmount+"",
            sEpayment: sumCurrencyElec+"",
            nEmpFund: form.getValues("nEmpFund"),
            nEmpMoney: form.getValues("nEmpMoney"),
            nSold: form.getValues("dSoldTicket").valueOf(),
            arrSeller: form.getValues("arrSeller") ?? [],
            lstSoldTicket: form.getValues("lstSoldTicket"),
            lstReturnTicket: form.getValues("lstReturnTicket"),
            lstCompareTicket: form.getValues("lstCompareTicket"),
            lstCurrencyElec: form.getValues("lstCurrencyElec"),
            lstCurrencyCoins: option.lstCurrencyCoins,
            lstCurrencyNotes: option.lstCurrencyNotes,
        };

        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            AxiosFn.Post(`SoldTicket/OnSubmitTicketSold`, objParam, (result) => {
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        gotoBack();
                    });
                } else { 
                    DialogFn.Warning(result.sMessage);                    
                }
            });
        });

    }

    const getSoldTicketType = (nMuseumID, dSold) => {
        if (!dSold) {
            return;
        }
        let param = {
            nMuseumID: nMuseumID,
            nSoldDate: dSold.valueOf()
        }
        DialogFn.BlockUI();
        AxiosFn.Get(`SoldTicket/GetSoldTicketType`, param, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            if (!objResult) {
                setDefaultValues(defaultValues => ({
                    ...defaultValues,
                    nMuseumID: nMuseumID,
                    dSoldTicket: null,
                    arrSeller: null,
                    lstSoldTicket: [],
                    lstReturnTicket: [],
                    lstCompareTicket: [],
                    lstCurrencyNotes: [],
                    lstCurrencyCoins: [],
                    lstCurrencyElec: [],
                }))
                DialogFn.Warning(result.sMessage);
                return;
            }
            setPolicyId(objResult.nPolicyID)
            setOption(option => ({
                ...option,
                lstEmpFund: objResult.lstEmpFund,
                lstEmpMoney: objResult.lstEmpMoney,
                lstSeller: objResult.lstSeller,
                lstTicketTypeNotFree: objResult.lstTicketTypeNotFree,
            }))

            setDefaultValues(defaultValues => ({
                ...defaultValues,
                nMuseumID: nMuseumID,
                dSoldTicket: dSold,
                arrSeller: objResult.arrUserwithdraw,
                lstSoldTicket: objResult.lstTypeTicket,
                lstReturnTicket: objResult.lstTypeTicketReturn,
                lstCompareTicket: objResult.lstTypeTicketCompare,
                lstCurrencyNotes: [],
                lstCurrencyCoins: [],
                lstCurrencyElec: objResult.lstTicketTypeNotFree,
            }))
            reset({
                ...watch(),
            });
        }, null, () => DialogFn.UnBlockUI());
    }

    const getOptionInitialData = async (nUserTypeID) => {
        DialogFn.BlockUI();
        if (objParamPath.ParamId) {
            await AxiosFn.Get(`SoldTicket/GetFormInfoSoldTicket`, { sSoldTicketID: objParamPath.ParamId }, (result) => {
                DialogFn.UnBlockUI();
                let objResult = result.objResult;
                if (objResult) {
                    // setIsView(false)
                    setStatusId(parseInt(objResult.sMode))
                    setIsView(![0,3].includes(objResult.sMode))
                    setObjMuseum({
                        nMuseumID: parseInt(objResult.objSold.sIDMuseum),
                        sMuseumName: objResult.objSold.sMuseum,
                    })

                    setOption(option => ({
                        ...option,
                        lstMuseum: objResult.lstMuseum,
                        lstEmpFund: objResult.lstEmpFund,
                        lstEmpMoney: objResult.lstEmpMoney,
                        lstSeller: objResult.lstSellerOption,
                        lstCurrencyNotes: objResult.objSold.lstCurrencyNotes,
                        lstCurrencyCoins: objResult.objSold.lstCurrencyCoins,
                        lstTicketTypeNotFree: objResult.lstTicketTypeNotFree,
                    }))

                    setDefaultValues(defaultValues => ({
                        ...defaultValues,
                        nMuseumID: parseInt(objResult.objSold.sIDMuseum),
                        sMuseum: objResult.objSold.sMuseum,
                        dSoldTicket: moment(objResult.objSold.nSold),
                        arrSeller: objResult.objSold.arrSeller,
                        nEmpFund: objResult.objSold.nEmpFund,
                        nEmpMoney: objResult.objSold.nEmpMoney,
                        lstSoldTicket: objResult.objSold.lstSoldTicket,
                        lstReturnTicket: objResult.objSold.lstReturnTicket,
                        lstCompareTicket: objResult.objSold.lstCompareTicket,
                        lstCurrencyNotes: objResult.objSold.lstCurrencyNotes,
                        lstCurrencyCoins: objResult.objSold.lstCurrencyCoins,
                        lstCurrencyElec: objResult.objSold.lstCurrencyElec,
                        sRemarkFlow : objResult.sRemark
                    }))

                    reset({
                        ...watch(),
                    });
                }
            }, null, () => DialogFn.UnBlockUI());
            return;
        }
        await AxiosFn.Get(`SoldTicket/GetFormInitialTicketSold`, null, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setOption(option => ({
                ...option,
                lstMuseum: objResult.lstMuseum,
                lstCurrencyNotes: objResult.lstCurrencyNotes,
                lstCurrencyCoins: objResult.lstCurrencyCoins,
            }))
            setObjMuseum({
                nMuseumID: objResult.nMuseumID,
                sMuseumName: objResult.sMuseumName,
            })

            setDefaultValues(defaultValues => ({
                ...defaultValues,
                nMuseumID: objResult.nMuseumID,
                sMuseum: objResult.sMuseumName,
                lstCurrencyNotes: objResult.lstCurrencyNotes,
                lstCurrencyCoins: objResult.lstCurrencyCoins,
            }))

            if (objResult.isDefaultDate && nUserTypeID === 1) {
                getSoldTicketType(objResult.nMuseumID, moment())
            }
        }, null, () => DialogFn.UnBlockUI());
    };


    return {
        statusId,
        isView,
        objParamPath,
        form,
        gotoBack,
        handleSubmitForm,
        objMuseum,
        option,
        defaultValues,
        getSoldTicketType,
        setObjTotal,
        setObjTotalMoney,
        nUserType,
        ExportPDF,
    }

}